import React, { Suspense, useContext, useMemo } from 'react';
import { LoadingBounce } from '@michelin/acid-components';
import { CentralProviderContext, CentralProviderState } from '@michelin/central-provider';
import { useGoogleAnalytics } from 'hooks/useGoogleAnalytics';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface Props extends RouteProps {
  component: () => JSX.Element;
}

function PrivateRoute({ component: Component, ...rest }: Props) {
  const ReactGA = useGoogleAnalytics();
  const { centralProfile } = useContext<CentralProviderState>(CentralProviderContext);

  const auth = useMemo(() => 
    centralProfile &&
    centralProfile.grants &&
    centralProfile.grants.length > 0
  , [centralProfile]);

  return useMemo(
    () => (
      <Route
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        render={(props) => {
          props.history.listen((h) => {
            ReactGA.set({ page: h.pathname });
            ReactGA.pageview(h.pathname);
          });
          if (auth)
            return (
              <Suspense fallback={<LoadingBounce style={{ height: '90vh' }} />}>
                <Component />
              </Suspense>
            );
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: props.location },
              }}
            />
          );
        }}
      />
    ),
    [auth, Component, rest, ReactGA],
  );
}

export default PrivateRoute;
